import React from 'react';
import {Navigate, Outlet} from 'react-router-dom';
import useAuth from '@mgp-fe/shared/modules/auth/hooks/useAuth.ts';
import {Customer} from '@mgp-fe/shared/core-api/domain/user.ts';
import routes from '@mgp-fe/customer/router/routes.ts';
import Logo from "@mgp-fe/shared/assets/logo/text-logo.svg";

export default function OnboardingGuard() {
	const {user, isUserLoading} = useAuth<Customer>();

	if (isUserLoading) return <div className='w-screen h-screen flex flex-col items-center justify-center animate-pulse gap-8'>
		<Logo className='fill-primary w-52 md:w-72 lg:w-80'/>
		<h1 className='h3 md:h2 lg:h3 uppercase text-secondary text-4xl font-semibold'>Loading...</h1>
	</div>;

	if (!user || user['@type'] !== 'Customer') return <Outlet/>;

	if (user.state !== 'converted') {
		return <Navigate to={routes.onboarding.index} replace/>;
	}

	return <Outlet/>;
}